/* eslint-disable react/sort-comp */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-undef */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from "underscore";
import { v4 as uuidv4 } from "uuid";
import { LOCATIONS_VIA_ADDRESS_QUERY, STORES_QUERY } from "../../graphql/location";
import { client, setSessionToken } from "../../shared/utilities/config";
import {setCaptchaToken} from "../../shared/utilities/captcha";
import captchaAction from "../../shared/constants/captchaAction";
import httpStatusConstant from "../../shared/constants/httpStatus";
import ReCAPTCHAForm from "../ReCaptcha/ReCaptcha";
import elementConstants from "../../shared/constants/element";
import { orderMethods } from "../../shared/constants/order";
import styles from './StorePicker.module.css';
import DeliveryLocationListItem from "../DeliveryLocationsListItem/DeliveryLocationsListItem";
import CalEmbed from "../CalEmbed/CalEmbed";
import Loader from "../Loader/Loader";


const searchIcon = require("../../pages/Locations/imgs/search-icon.svg");
const searchArrow = require("../../pages/Locations/imgs/current-location-icon.svg");
const locationIcon = require("../../pages/Locations/imgs/location-icon.svg");
const clearIcon = require("../../pages/Locations/imgs/close-icon.svg");
const lightExitIcon = require("../../pages/Locations/imgs/light-exit-icon.svg");

class StorePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locationsList: [],
      searchValue: '',
      selectedAddress: "",
      locationLoading: false,
      storesLoading: false,
      selectedStoreIdFromTheSearchList: null,
      showLocationSearchResults: false,
      hasCaptchaError: false,
      showCaptchaChallenge: false,
      skipGenerateNewToken: false,
      locationSearchError: null,
      addressesData: null,
      addressesLoading: false,
      myLocation: null,
      myAddress: '',
    };
    this.searchInput = React.createRef();
    this.recaptchaComponentRef = React.createRef();

    this.setSearchPosition = this.setSearchPosition.bind(this);
    this.myLocationSearch = this.myLocationSearch.bind(this);
  }

  componentDidMount() {
   setSessionToken(uuidv4());
   const { useRecaptcha, setVerificationToken, setVerificationAction } = this.props;

   if (useRecaptcha === 1) {
     const { skipGenerateNewToken } = this.state;
     setCaptchaToken(setVerificationToken, setVerificationAction, captchaAction.addressSearching, skipGenerateNewToken);
   }

   this.initState();
  }

  initState() {
   const { location } = this.props;
   
   if (location && location.state && location.state.showLocationSearchResults) {
     this.setState({
       showLocationSearchResults: location.state.showLocationSearchResults,
       searchValue: location.state.selectedAddress
     });
   }

   if (
     location &&
     location.state &&
     location.state.myLocation &&
     location.state.searchLocation &&
     location.state.selectedAddress &&
     location.state.stores
   ) {
     const locationsList = location.state.stores ? location.state.stores : [];
     
     this.setState({
       myLocation: { lat: "", lng: "" },
       locationsList,
       selectedAddress: location.state.selectedAddress,
       searchValue: location.state.selectedAddress,
     });
   }

   this.getCurrentPosition();
  }

  getCurrentPosition() {
   const { location } = this.props;
   const locationDefined = location && !!(location.lat && location.lng);

   if (locationDefined) {
     // If location is already defined, use it to get stores
     this.setSearchPosition(null);
     return;
   }

   this.setState({ locationLoading: true });
   import("../../shared/utilities/geolocation").then(({ getCurrentPosition }) => {
     getCurrentPosition(this.setSearchPosition, this);
   });
  }

  setSearchPosition(response) {
   const { searchValue, selectedAddress } = this.state;
   const { location } = this.props;
   const hasSelectedAddress = location && location.state && location.state.selectedAddress;
   let address = "";

   if (
     (selectedAddress === "" || selectedAddress === undefined) &&
     response &&
     response.results &&
     response.results[0] &&
     response.results[0].place_id &&
     response.results[0].geometry &&
     response.results[0].geometry.location &&
     response.results[0].geometry.location.lat &&
     response.results[0].geometry.location.lng
   ) {
     this.setState({
       myLocation: {
         externalId: response.results[0].place_id,
         lat: response.results[0].geometry.location.lat,
         lng: response.results[0].geometry.location.lng
       }
     });
   }

   if (searchValue !== "" && searchValue !== undefined) {
     this.setState({
       locationLoading: false
     });
     return null;
   }

   if (!response) {
     const data = {
       searchValue: address,
       locationLoading: false,
       selectedAddress: address
     };

     if (location && location.state) {
       address = location.state.selectedAddress;

       data.selectedAddress = address;
       data.searchValue = address;

       this.getStores(location.state.searchLocation);
     } else if (location && location.lat && location.lng) {
       // If location prop has lat/lng but no state, use it to get stores
       address = location.formatted_address || location.address || '';
       data.searchValue = address;
       data.selectedAddress = address;
       
       this.getStores({ lat: location.lat, lng: location.lng });
     }

     this.setState({
       locationLoading: false,
       searchValue: address,
       selectedAddress: address
     });
     return null;
   }

   address = hasSelectedAddress
     ? location.state.selectedAddress
     : response.results[0].formatted_address;

   const myAddress = response.results[0].formatted_address;
   const externalId = response.results[0].place_id;

   const positionLocation = {
     externalId
   };

   const stateSearchLocation = hasSelectedAddress
     ? location.state.searchLocation
     : positionLocation;

   this.setState({
     locationLoading: false,
     searchValue: address,
     selectedAddress: address,
     myLocation: positionLocation,
     myAddress
   });

   if (location && location.state && !location.state.stores.length) {
     return this.getStores(stateSearchLocation);
   }
   
   // Always call getStores when we have a valid geolocation response
   if (response && response.results && response.results[0]) {
     return this.getStores(stateSearchLocation);
   }
   
   return null;
  }

  async getStores(variables) {
   const { storesLoading } = this.state;

   if (storesLoading) {
     return;
   }

   this.setStoreLoading(true);

   try {
     const response = await client.query({
       query: STORES_QUERY,
       fetchPolicy: "network-only",
       variables
     });

     this.getStoresCallback(response.data.storeSearch);
   } catch (e) {
     this.setStoreLoading(false);
   }
  }

  getStoresCallback(storeSearch) {
    let locationsList = storeSearch.stores ? storeSearch.stores : [];
    const { filteredStores } = this.props;

    // Filter stores to only show those that have calendars (in filteredStores prop)
    if (filteredStores && filteredStores.length > 0) {
      locationsList = locationsList.filter(store => {
        const matchFound = filteredStores.some(filteredStore =>
          String(filteredStore.storeId) === String(store.id)
        );
        return matchFound;
      });
    }

    // Add calendar links from filteredStores to the filtered stores
    if (filteredStores && filteredStores.length > 0 && locationsList.length > 0) {
      locationsList = locationsList.map(store => {
        const filteredStore = filteredStores.find(fs => String(fs.storeId) === String(store.id));
        if (filteredStore && filteredStore.calendarLink) {
          return { ...store, calendarLink: filteredStore.calendarLink };
        }
        return store;
      });
    }

    if (locationsList.length > 0) {
      setSessionToken(uuidv4());
    }
    this.setState({
      locationsList,
      showLocationSearchResults: locationsList.length > 0,
      storesLoading: false,
    });
  }

  myLocationSearch() {
    const { myAddress, myLocation } = this.state;

    if (myLocation) {
      this.setState({
        searchValue: myAddress
      });

      this.getStores(myLocation);
    }
  }

  clearSearch = () => {
    this.setState({
      searchValue: "",
      selectedAddress: "",
      showLocationSearchResults: false,
    });
    this.searchInput.current.focus();
  };

  handleSearchSubmit = (e) => {
    const { searchValue, myLocation } = this.state;
    if (e.key === 'Enter' && searchValue.length > 0) {
      e.preventDefault();
      const { lat, lng } = myLocation || { lat: null, lng: null };
      const addressQueryVars = {
        address: searchValue,
        fullyQualified: false,
        showDorms: false
      };
      if (lat && lng) {
        addressQueryVars.lat = parseFloat(lat);
        addressQueryVars.lng = parseFloat(lng);
      }
      this.handleLocationFilter(searchValue, addressQueryVars);
    }
  };

  handleInputChange = (value) => {
    const { myLocation } = this.state;
    const { userOrderMethod } = this.props;
    const showDorms = userOrderMethod !== orderMethods.shipping ?? false;
    
    const addressQueryVars = {
      address: value,
      fullyQualified: false,
      showDorms
    };
    
    if (myLocation && myLocation.lat && myLocation.lng) {
      addressQueryVars.lat = parseFloat(myLocation.lat);
      addressQueryVars.lng = parseFloat(myLocation.lng);
    }
    
    this.handleLocationFilter(value, addressQueryVars);
  };

  handleLocationFilter(value, variables) {
    const { locationsList, selectedAddress } = this.state;
    const minLengthMet = value.length > 2;
    
    // Reset selectedAddress when input changes to allow new searches
    if (value !== selectedAddress) {
      this.setState({
        selectedAddress: "",
      });
    }
    
    this.setState({
      searchValue: value,
      showLocationSearchResults: false, // Hide previous results while typing
      selectedStoreIdFromTheSearchList: null, // Clear selected store when input changes
      locationsList: [], // Clear previous store suggestions
    });

    if (variables && minLengthMet) {
      const query = variables;
      query.address = value;
      this.getAddressesDebounced(query);
    }
    return null;
  }

  getAddressesDebounced = _.debounce(async (variables) => {
    const { useRecaptcha, setVerificationToken, setVerificationAction } = this.props;
    const { skipGenerateNewToken } = this.state;
    if (useRecaptcha === 1) {
      await setCaptchaToken(setVerificationToken, setVerificationAction, captchaAction.addressSearching, skipGenerateNewToken);
    }
    this.getLocations(variables);
  }, 500);

  async getLocations(variables) {
    this.setState({ addressesLoading: true });
    const { setVerificationProvider } = this.props;

    try {
      const response = await client
        .query({
          query: LOCATIONS_VIA_ADDRESS_QUERY,
          fetchPolicy: "no-cache",
          variables
        });

      this.setState({
        addressesData: response.data,
        addressesLoading: false,
        locationLoading: false,
        showLocationSearchResults: false,
      });
      setVerificationProvider('');
    } catch (e) {
      this.locationErrorHandler(e.message)
    }
  }

  locationErrorHandler = (errorMsg) => {
    const hasUnauthorized = errorMsg.indexOf(httpStatusConstant.unauthorised) !== -1;
    if (hasUnauthorized) {
      this.setState({
        hasCaptchaError: hasUnauthorized,
        showCaptchaChallenge: hasUnauthorized,
      });
    } else {
      this.setState({
        showCaptchaChallenge: false,
        hasCaptchaError: false,
        skipGenerateNewToken: false,
        addressesData: {
          locationSearch: []
        },
      });
    }
    this.setState({ addressesLoading: false, locationSearchError: errorMsg });
  }

  setStoreLoading(isStoreLoading) {
    this.setState({
      storesLoading: isStoreLoading
    });
  }

  onVerifyCaptcha = (token) => {
    if (token) {
      this.setState({
        showCaptchaChallenge: false,
        skipGenerateNewToken: true
      });

      const { setVerificationToken, setVerificationProvider, userOrderMethod } = this.props;
      const { searchValue } = this.state;
      setVerificationToken(token);
      setVerificationProvider(elementConstants.challengeRecaptcha);

      const showDorms = userOrderMethod !== orderMethods.shipping ?? false;

      const addressQueryVars = {
        address: searchValue,
        fullyQualified: false,
        showDorms
      };
      this.handleLocationFilter(searchValue, addressQueryVars);
    }
  }

  renderCaptchaChallenge = () => {
    const { showCaptchaChallenge } = this.state;
    const { useRecaptcha } = this.props;
    return (
      (showCaptchaChallenge && useRecaptcha) ? (
        <div className={styles.errorContainer}>
          <ReCAPTCHAForm
            ref={this.recaptchaComponentRef}
            setToken={this.onVerifyCaptcha}
          />
        </div>
      ) : null
    );
  };

  renderErrorUI = () => (
    <div className={styles.errorContainer}>
      <p>Oops, something went wrong</p>
      <p>There was a network error, try refreshing your browser.</p>
      <button type="button" onClick={() => window.location.reload()}>Reload Page</button>
    </div>
  );

  renderListSearch = () => {
    const {
      searchValue,
      selectedAddress,
      locationLoading,
      locationsList,
      myLocation,
      myAddress,
      addressesData,
      addressesLoading,
      storesLoading,
      hasCaptchaError,
      locationSearchError
    } = this.state;
    const { lat, lng } = myLocation || { lat: "", lng: "" };
    const { userOrderMethod } = this.props;
    const showDorms = userOrderMethod !== orderMethods.shipping ?? false;


    const addressQueryVars = {
      address: searchValue,
      fullyQualified: false,
      showDorms
    };

    // Always include lat/lng if available, but don't require them
    if (lat && lng) {
      addressQueryVars.lat = parseFloat(lat);
      addressQueryVars.lng = parseFloat(lng);
    }

    return (
      <div style={{ height: !locationsList.length ? "100%" : "" }}>
        <div className={`${styles.locationsInputWrapper}`}>
          <div
            className={`
            border-[1px] border-lightDry rounded-[48px] px-4
            ${styles.locationInputContainer}
            `}
          >
            <img alt="" src={searchIcon} />
            <input
              type="text"
              id="search_location"
              ref={this.searchInput}
              value={searchValue}
              className="text-dark dark:text-white bg-transparent inputDarkModeOverride"
              onChange={e => this.handleInputChange(e.target.value)}
              onKeyDown={this.handleSearchSubmit}
              placeholder="Enter address to find participating bakeries nearby"
            />
            {searchValue.length > 0 &&
            !addressesLoading ? (
              <>
                <button
                  onClick={this.clearSearch}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      this.clearSearch();
                    }
                  }}
                  className={`${styles.clearIcon}  dark:hidden !bg-transparent w-4 h-4 items-center flex justify-center`}
                  type="button"
                  aria-label="Clear search"
                >
                  <img
                    alt=""
                    src={clearIcon}
                    aria-hidden="true"
                  />
                </button>
                <button
                  onClick={this.clearSearch}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      this.clearSearch();
                    }
                  }}
                  className={`${styles.clearIcon} hidden dark:flex !bg-transparent w-4 h-4 items-center  justify-center`}
                  type="button"
                  aria-label="Clear search"
                >
                  <img
                    alt=""
                    src={lightExitIcon}
                    aria-hidden="true"
                  />
                </button>
              </>
            ) : null}
          </div>
          {locationLoading ? (
            <span>
              {/* Loader removed - using global loader instead */}
            </span>
          ) : (
            myLocation && (
              <button
                type="button"
                onClick={this.myLocationSearch}
                aria-label="Use my current location"
                className="bg-transparent border-none p-0 ml-4"
                style={{ width: 'auto' }}
              >
                <img
                  alt=""
                  src={searchArrow}
                  style={{ width: '24px', height: '24px' }}
                />
              </button>
            )
          )}
        </div>
        <div className={styles.autocompleteContainer}>
          {hasCaptchaError ? this.renderCaptchaChallenge() : locationSearchError ? this.renderErrorUI() : null}
          {addressesLoading ? null : (
            searchValue.length > 0 &&
            !selectedAddress &&
            addressesData &&
            addressesData.locationSearch.length > 0 ? (
              <div className={styles.locationSearchAutoComplete}>
                {addressesData.locationSearch.map((location) => (
                  <DeliveryLocationListItem
                    customStyles={styles.customLocationItemStyles}
                    onClick={() => {
                      const { externalId, lat: locationLat, lng: locationLng } = location;
                      this.setState({
                        searchValue: location.address1,
                        selectedAddress: location.address1,
                        showLocationSearchResults: true,
                      });
                      this.getStores({ externalId, lat: locationLat, lng: locationLng });
                    }}
                    key={location.address1}
                    icon={locationIcon}
                    address1={location.address1}
                    addressDetails={location.addressDetails}
                  />
                ))}
              </div>
            ) : null
          )}
          {searchValue.length > 0 &&
          selectedAddress &&
          storesLoading ? (
            <div className={styles.storeList}>
              <Loader />
            </div>
          ) : null}
          {searchValue.length > 0 &&
          (selectedAddress || (myLocation && searchValue === myAddress)) &&
          !storesLoading &&
          !locationsList.length ? (
            <div className={styles.storeList}>
              <div
                className={styles.noStoresFound}
                role="status"
                aria-live="polite"
              >
                <h3 className="text-button dark:text-button">Unfortunately, there are no participating bakeries near that address</h3>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  render() {
    const { onSelectStore, selectedStoreId } = this.props;
    const { locationsList, showLocationSearchResults, selectedStoreIdFromTheSearchList } = this.state;

    // Use the local state selectedStoreId if available, otherwise fall back to props
    const effectiveSelectedStoreId = selectedStoreIdFromTheSearchList || selectedStoreId;
    
    // Find the selected store to get its calendar link
    const selectedStore = locationsList.find(store => store.id === effectiveSelectedStoreId);
    const selectedStoreCalendarLink = selectedStore?.calendarLink;
    

    return (
      <div className={`${styles.locationsContainer}`}>
        {this.renderListSearch()}
        {showLocationSearchResults && locationsList.length > 0 && (
          <div className={styles.storeList}>
            {locationsList.map((store, index) => {
              const { id, name, mailingAddress, city, state, zip, calendarLink, phone, distanceToStore, isPickupOpen } = store;
              return (
                <div
                  key={id}
                  className={`${styles.listItemWrapper}
                          ${effectiveSelectedStoreId === id ? styles.selected : ''}
                          border-b-[1px] border-light dark:border-darkDry
                        `}
                  onClick={() => {
                    onSelectStore(store);
                    this.setState({
                      selectedStoreIdFromTheSearchList: id
                    });
                  }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      onSelectStore(store);
                      this.setState({
                        selectedStoreIdFromTheSearchList: id
                      });
                    }
                  }}
                >
                  <div
                    className={`${styles.listItemContainer}
                            md:py-6 py-2 px-4`}
                  >
                    <div className={`${styles.listItemHeader} text-dark dark:text-white`}>
                      <h3 className="flex items-center gap-2 w-[64%] md:w-full">
                        <span>{name}</span>
                      </h3>
                    </div>
                    <div
                      className={`${styles.listItemLocation} text-darkElevationPrimary dark:text-darkElevationSecondary flex flex-col gap-2`}
                    >
                      <p className="truncate overflow-ellipsis overflow-hidden w-[250px]">
                        {mailingAddress}
                        <br />
                        {city}
,
                        {state}
,
                        {zip}
                      </p>
                      {phone && (
                        <p>
                          {phone}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

StorePicker.propTypes = {
  selectedStoreId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelectStore: PropTypes.func.isRequired,
  useRecaptcha: PropTypes.number,
  setVerificationToken: PropTypes.func,
  setVerificationAction: PropTypes.func,
  setVerificationProvider: PropTypes.func,
  userOrderMethod: PropTypes.string,
  location: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  filteredStores: PropTypes.arrayOf(PropTypes.shape({
    storeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    calendarLink: PropTypes.string.isRequired,
  })),
};

StorePicker.defaultProps = {
  selectedStoreId: null,
  useRecaptcha: 0,
  setVerificationToken: () => {},
  setVerificationAction: () => {},
  setVerificationProvider: () => {},
  userOrderMethod: null,
  location: null,
  filteredStores: null,
};

export default StorePicker;